<template >
  <router-view />
</template>

<style>
#app, body, html {
  width: 100%;
  height: 100%;
  background-color: var(--el-bg-color);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}
</style>
